import React from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@bem-react/classname';
import { Logout } from 'assets';
import { logout } from 'store/action/auth';
import { useAppSelector } from 'store/store';

import { Logo } from 'components';

import './Header.scss';

const CnHeader = cn('header navbar navbar-expand-lg bg-body-tertiary');

interface IHeaderProps {
    withNavigation?: boolean;
    withProfile?: boolean;
}

const navItems: Array<{
    title: string;
    path: string;
    accessField: string;
}> = [
    {
        title: 'Платформы',
        path: '/platforms',
        accessField: 'platformRule',
    },
    {
        title: 'Администраторы',
        path: '/admins',
        accessField: 'adminRule',
    },
    {
        title: 'События',
        path: '/events',
        accessField: 'eventRule',
    },
    {
        title: 'Шаблоны',
        path: '/templates',
        accessField: 'templateRule',
    },
    {
        title: 'Сообщения',
        path: '/sended',
        accessField: 'messageRule',
    },
    {
        title: 'Получатели',
        path: '/receivers',
        accessField: 'userRule',
    },
    {
        title: 'Переменные',
        path: '/variables',
        accessField: 'variableRule',
    },
];

export const Header: React.FC<IHeaderProps> = ({ withNavigation = true, withProfile = true }) => {
    const location = useLocation();
    const dispatch = useDispatch();

    const {
        login: { name = '' },
        access,
    } = useAppSelector((store) => store.auth);

    const logoutClickHandler = () => {
        dispatch(logout());
    };

    return (
        <nav className={CnHeader({withNavigation, withProfile})}>
            <div className="container-fluid">
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false"
                        aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <span className="navbar-brand" > <Logo/></span>
                <div className="collapse navbar-collapse" id="navbarTogglerDemo03">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0 flex-column ">
                        {withNavigation ? (
                            <li className={`${CnHeader('navigation nav-mobile-el')} ${CnHeader('item')}`}>
                                {navItems.map((item, index) => {
                                    if (access[item.accessField] === 1) {
                                        return (
                                           <Link
                                                className={
                                                    location.pathname.includes(item.path)
                                                        ? CnHeader('navigation header-navigation', {checked: true})
                                                        : ''
                                                }
                                                to={item.path}
                                                key={index}
                                            >
                                                {item.title}
                                            </Link>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                            </li>
                        ) : (
                            <li></li>
                        )}
                    </ul>
                    <form className="d-flex">
                        {withProfile ? (
                            <div className={`${CnHeader('profile')} ${CnHeader('item')}`}>
                                <div className={CnHeader('name')}>{name}</div>

                                <div onClick={logoutClickHandler} className={CnHeader('icon')}>
                                    <Logout/>
                                </div>
                            </div>
                        ) : (
                            <div></div>
                        )}
                    </form>
                </div>
            </div>
        </nav>
    );
};
